/* jshint esversion: 6 */
/* jshint ignore:start */
import { useContext, useRef, useState } from 'react';
import PhoneInput, { formatPhoneNumberIntl } from "react-phone-number-input";
import "react-phone-number-input/style.css";
import { MyContext } from '../Context/MyProvider';
import { showToast } from '../showTost';
import axios from 'axios';
import Callicon from '../assets/Icon/call.svg';
import Lockicon from '../assets/Icon/lock.svg';
import Eyeicon from '../assets/Icon/eye.svg';
import Eyeslashicon from '../assets/Icon/eye-slash.svg';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Emailicon from '../assets/Icon/email.svg';
import secureLocalStorage from "react-secure-storage";
import Logo from "../assets/Image/Logo.png";
const Login = () => {

    const { t } = useTranslation();
    const { setIsLoginShow, setIsSignUpShow, ApiBaseUrl, setIsLogin } = useContext(MyContext);

    const [value, setValue] = useState();
    const [password, setPassowrd] = useState("");
    const [email, setEmail] = useState("");
    const [passType, setPassType] = useState("Password");
    const [passType2, setPassType2] = useState("Password");
    const [passType3, setPassType3] = useState("Password");
    const [isPageShow, setIsPageShow] = useState("Login");
    const [forgot, setForgot] = useState("");
    const [otpBox, setOtpBox] = useState(Array(6).fill(''));
    const [sendOtp, setSendOtp] = useState("");
    const [newPassword, setNewPassword] = useState({ passowrd: "", confirm: "" });
    const [apiloading, setApiLoading] = useState(false);
    const [selecttype, setSelectType] = useState("Phone");

    const InputRef = useRef();
    const OtpRef = useRef(Array.from({ length: 6 }, () => null));

    const Navigate = useNavigate();

    const handleLogin = () => {

        if (apiloading) {
            return;
        }

        const Error = selecttype === "Phone" ? value : email;
        const toastTitle = selecttype === "Phone" ? "Please enter number" : "Please enter email";

        if (!Error) {
            showToast({ title: t(toastTitle), id: "warning" });
            return;
        }

        if (!password) {
            showToast({ title: t("Please enter password"), id: "warning" });
            return;
        }

        try {

            const formattedNumber = formatPhoneNumberIntl(value);
            const countryCode = formattedNumber.split(' ')[0];
            const numberWithoutCode = formattedNumber.replace(countryCode, '').trim();
            const cleanedNumber = numberWithoutCode.split(' ').join('');

            setApiLoading(true);

            const ulogin_data = selecttype === "Phone" ? cleanedNumber : email;

            const loginData = {
                ulogin_data,
                c_code: countryCode,
                password: password
            };

            axios.post(`${ApiBaseUrl}/customer/login`, loginData)
                .then(response => {
                    const { ResponseCode, message, customer_detail } = response.data;

                    console.log("Login Api", response.data);

                    if (ResponseCode === 200) {
                        showToast({ title: message, id: "success" });
                        Navigate("/");
                        secureLocalStorage.setItem("Loginuser", JSON.stringify(customer_detail));
                        secureLocalStorage.setItem("Userid", customer_detail.id);
                        setIsLogin("123");
                        setIsLoginShow(false);
                    } else {
                        showToast({ title: message, id: "error" });
                    }
                    setApiLoading(false);
                })
                .catch(err => {
                    console.error("Login Error:", err);
                });
        } catch (error) {
            console.error("Phone number formatting error:", error);
        }
    };

    const HandleChange = (index, value) => {
        const OTP = [...otpBox];
        OTP[index] = value;
        setOtpBox(OTP);
        if (value && !isNaN(value) && index < OtpRef.current.length - 1) {
            OtpRef.current[index + 1].focus();
        }
    };

    const HandleKeyPress = (index, e) => {
        if (e.key === "Backspace" && index > 0 && !e.target.value) {
            OtpRef.current[index - 1].focus();
        }
    };

    const HandleContinue = () => {

        if (apiloading) {
            return;
        }

        if (!forgot) {
            showToast({ title: t("Please enter number"), id: "warning" });
            return;
        }

        const formattedNumber = formatPhoneNumberIntl(forgot);
        const countryCode = formattedNumber.split(' ')[0];
        const numberWithoutCode = formattedNumber.replace(countryCode, '').trim();
        const cleanedNumber = numberWithoutCode.split(' ').join('');

        const Data = {
            phone: cleanedNumber,
            ccode: countryCode,
        };

        setApiLoading(true);

        axios.post(`${ApiBaseUrl}/customer/mobile_check`, Data)
            .then((res) => {
                // console.log("mobile_check", res);
                const { ResponseCode, message, Result } = res.data;
                if (ResponseCode === 200 && !Result) {
                    axios.get(`${ApiBaseUrl}/customer/otp_detail`)
                        .then((res) => {
                            // console.log("otp_detail", res);
                            const { message } = res.data;
                            if (message === "MSG91") {
                                handleMSG91(Data);
                            } else if (message === "Twilio") {
                                handleTwilio(Data);
                            } else {
                                setIsPageShow("NewPass");
                            }
                        })
                        .catch((error) => {
                            console.error("otp_detail", error);
                        });
                } else {
                    showToast({ title: message, id: "error" });
                    setApiLoading(false);
                }
            })
            .catch((error) => {
                console.error("mobile_check", error);
            });
    };

    const handleMSG91 = (data) => {
        axios.post(`${ApiBaseUrl}/customer/msg91`, data)
            .then((res) => {
                // console.log("msg91", res);
                const { ResponseCode, message, otp } = res.data;
                if (ResponseCode === 200) {
                    setApiLoading(false);
                    showToast({ title: message, id: "success" });
                    setIsPageShow("OTP");
                    setSendOtp(otp);
                }
            });
    };

    const handleTwilio = (data) => {
        axios.post(`${ApiBaseUrl}customer/twilio`, data)
            .then((res) => {
                // console.log("twilio", res);
                const { ResponseCode, message, otp } = res.data;
                if (ResponseCode === 200) {
                    setApiLoading(false);
                    showToast({ title: message, id: "success" });
                    setIsPageShow("OTP");
                    setSendOtp(otp);
                }
            });
    };

    const HandleVerifyOTP = () => {
        if (sendOtp === otpBox.join("")) {
            setIsPageShow("NewPass");
        } else {
            showToast({ title: t("OTP is invalid !!"), id: "error" });
        }
    };

    const HandleResetPass = () => {

        if (apiloading) {
            return;
        }

        if (!newPassword.passowrd && !newPassword.confirm) {
            showToast({ title: t("Enter Password !!"), id: "error" });
            return;
        }

        if (newPassword.passowrd === newPassword.confirm) {

            const formattedNumber = formatPhoneNumberIntl(forgot);
            const countryCode = formattedNumber.split(' ')[0];
            const numberWithoutCode = formattedNumber.replace(countryCode, '').trim();
            const cleanedNumber = numberWithoutCode.split(' ').join('');

            const Data = {
                phone: cleanedNumber,
                ccode: countryCode,
                password: newPassword.confirm
            };

            setApiLoading(true);

            axios.post(`${ApiBaseUrl}/customer/forgot_password`, Data)
                .then((res) => {
                    // console.log("forgot_password", res);
                    setApiLoading(false);
                    const Id = res.data.ResponseCode === 200 ? "success" : "error";
                    showToast({ title: res.data.message, id: Id });
                    setIsLoginShow(false);
                })
                .catch((error) => {
                    console.error("forgot_password", error);
                });

        } else {
            showToast({ title: t("Not Match Password !!"), id: "error" });
        }
    };

    return (
        <div>

            {isPageShow === "Login" && <div className="py-[10px] px-[20px] login-box">
                <img src={Logo} className='w-[80px]' alt="Logo" />
                <span className="text-gray-500 text-[17px] font-bold">welcome back Please enter your details.</span>

                <div className="border-[1px] inline-block rounded-[50px] p-[5px] mt-[5px]">
                    <div className="flex items-center gap-[5px]">
                        <button onClick={() => setSelectType("Phone")} className={`w-[100px] duration-[0.5s] ${selecttype === "Phone" && "bg-[#0d4047] text-white"} py-[4px] rounded-[50px] font-bold text-[15px]`} >Phone</button>
                        <button onClick={() => setSelectType("Email")} className={`w-[100px] duration-[0.5s] ${selecttype === "Email" && "bg-[#0d4047] text-white"} py-[4px] rounded-[50px] font-bold text-[15px]`} >Email</button>
                    </div>
                </div>

                {selecttype === "Phone"
                    ? <div className="relative gap-[5px] login-input focus-within:border-[#0d4047] mt-[10px] focus-within:border-[1px]">
                        <img src={Callicon} alt="Call Icon" className="w-[25px]" />
                        <PhoneInput
                            className="w-[100%]"
                            ref={InputRef}
                            international
                            defaultCountry="IN"
                            value={value}
                            onChange={setValue}
                            name="phone"
                            style={{ outline: "none" }}
                        />
                        {!value && <h1 onClick={() => InputRef.current.focus()} className='absolute top-[10px] left-[90px] text-gray-500'>Phone Number</h1>}
                    </div>
                    : <div className="login-input focus-within:border-[#0d4047] mt-[10px] focus-within:border-[1px]">
                        <img src={Emailicon} alt="EmailIcon" className="w-[25px]" />
                        <input onChange={(e) => setEmail(e.target.value)} type="text" placeholder='Email' className='w-[100%] bg-transparent outline-none px-[10px]' />
                    </div>}

                <div className="login-input focus-within:border-[#0d4047] mt-[20px] focus-within:border-[1px]">
                    <img src={Lockicon} alt="Lockicon" className="w-[25px]" />
                    <input onChange={(e) => setPassowrd(e.target.value)} className="bg-transparent px-[10px] w-[100%] outline-none" type={passType} placeholder="Passowrd" />
                    <img onClick={() => passType === "text" ? setPassType("Password") : setPassType("text")} src={passType === "text" ? Eyeicon : Eyeslashicon} alt="LockIcon " className="w-[20px] cursor-pointer" />
                </div>
                <button onClick={() => setIsPageShow("Forgot")} className='font-bold mt-[10px] '>Forgot passowrd? <span className='text-[#0d4047]'>Reset it</span></button>
                <button onClick={handleLogin} className="bg-[#0d4047] w-[100%] py-[8px] text-white font-bold rounded-[10px] mt-[20px] ">
                    {apiloading
                        ? <div className="loader mx-auto"></div>
                        : <span>Sign In</span>}
                </button>
                <h1 className="mt-[10px] text-center font-bold">Don't have and account? <button onClick={() => { setIsLoginShow(false); setIsSignUpShow(true); }} className="text-[#0d4047] cursor-pointer">Sign Up</button> </h1>
            </div>}

            {isPageShow === "Forgot" && <div className="py-[10px] px-[20px]">
                <h1 className='text-center text-[24px] font-bold'>Can't Sign in?</h1>
                <p className='text-center text-gray-500 text-[18px] leading-[25px]'>Enter the mobile number associated with you account, and RideNow will send you OTP to your register mobile number</p>
                <div className="relative login-input focus-within:border-[#0d4047] mt-[20px] focus-within:border-[1px]">
                    <img src={Callicon} alt="Call Icon" className="w-[25px]" />
                    <PhoneInput
                        className="w-[100%]"
                        ref={InputRef}
                        international
                        defaultCountry="IN"
                        value={forgot}
                        onChange={setForgot}
                        name="phone"
                        style={{ outline: "none" }}
                    />

                    {!forgot && <h1 onClick={() => InputRef.current.focus()} className='absolute top-[10px] left-[90px] text-gray-500'>Phone Number</h1>}
                </div>

                <button onClick={HandleContinue} className='w-[100%] bg-[#0d4047] font-bold py-[8px] mt-[25px] text-white rounded-[10px]'>
                    {apiloading
                        ? <div className="loader mx-auto"></div>
                        : <span>Continue</span>}
                </button>
                <button onClick={() => setIsPageShow("Login")} className="w-[100%] border-[1px] border-[#0d4047] font-bold py-[8px] mt-[10px] text-[#0d4047] rounded-[10px]">Return to Sign In</button>
            </div>}

            {isPageShow === "OTP" && <div className="py-[10px] px-[20px] signup-box">
                <h1 className='font-bold text-[20px]'>Awesome</h1>
                <p>We have send the OTP to {forgot}</p>
                <h1>Your OTP :- {sendOtp}</h1>
                <div className="flex items-center gap-[20px] mt-[10px]">
                    {otpBox.map((value, index) => {
                        return <input
                            ref={(e) => (OtpRef.current[index] = e)}
                            key={index}
                            value={value}
                            className='otp-box focus-within:outline-[#0d4047]'
                            type="text"
                            maxLength="1"
                            onKeyDown={(e) => HandleKeyPress(index, e)}
                            onChange={(e) => HandleChange(index, e.target.value)}
                            inputMode="numeric"
                        />
                    })}
                </div>
                <button onClick={HandleVerifyOTP} className='w-[100%] bg-[#0d4047] font-bold py-[8px] mt-[25px] text-white rounded-[10px]'>VERIFY OTP</button>
            </div>}

            {isPageShow === "NewPass" && <div className="py-[10px] px-[20px]">
                <h1 className='font-bold text-[18px] text-center'>Create A New Password</h1>
                <div className="login-input focus-within:border-[#0d4047] mt-[20px] focus-within:border-[1px]">
                    <img src={Lockicon} alt="userIcon" className="w-[25px]" />
                    <input onChange={(e) => setNewPassword({ ...newPassword, passowrd: e.target.value })} type={passType2} placeholder='Password' className='w-[100%] bg-transparent outline-none px-[10px]' />
                    <img onClick={() => passType2 === "text" ? setPassType2("Password") : setPassType2("text")} src={passType2 === "text" ? Eyeicon : Eyeslashicon} alt="LockIcon " className="w-[20px] cursor-pointer" />
                </div>
                <div className="login-input focus-within:border-[#0d4047] mt-[20px] focus-within:border-[1px]">
                    <img src={Lockicon} alt="userIcon" className="w-[25px]" />
                    <input onChange={(e) => setNewPassword({ ...newPassword, confirm: e.target.value })} type={passType3} placeholder='Confrim Password' className='w-[100%] bg-transparent outline-none px-[10px]' />
                    <img onClick={() => passType3 === "text" ? setPassType3("Password") : setPassType3("text")} src={passType3 === "text" ? Eyeicon : Eyeslashicon} alt="LockIcon " className="w-[20px] cursor-pointer" />
                </div>

                <button onClick={HandleResetPass} className='w-[100%] bg-[#0d4047] font-bold py-[8px] mt-[25px] text-white rounded-[10px]'>
                    {apiloading
                        ? <div className="loader mx-auto"></div>
                        : <span>Continue</span>}
                </button>

            </div>}

        </div>
    )
}

export default Login
/* jshint ignore:end */